import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { User, FileText } from 'lucide-react';

export function ApplyScopePrompt({ open, onOpenChange, fields, employeeName, saving, onChoose }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md dark:bg-slate-800" data-testid="apply-scope-dialog">
        <DialogHeader>
          <DialogTitle className="dark:text-slate-100">Apply changes globally?</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600 dark:text-slate-300">
          You changed <span className="font-medium text-slate-900 dark:text-slate-100">{fields.join(', ')}</span>.
          Should these new values also become the default on {employeeName || 'this employee'}&apos;s profile for future payroll runs?
        </p>
        <div className="grid gap-2 mt-2">
          <button
            type="button"
            disabled={saving}
            onClick={() => onChoose(false)}
            data-testid="apply-scope-payslip-only"
            className="flex items-start gap-3 rounded-lg border border-slate-300 dark:border-slate-600 p-3 text-left hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
          >
            <FileText className="h-5 w-5 mt-0.5 text-slate-500" />
            <span>
              <span className="block text-sm font-medium text-slate-900 dark:text-slate-100">This payslip only</span>
              <span className="block text-xs text-slate-500 dark:text-slate-400">One-off change for this month. Employee profile unchanged.</span>
            </span>
          </button>
          <button
            type="button"
            disabled={saving}
            onClick={() => onChoose(true)}
            data-testid="apply-scope-profile"
            className="flex items-start gap-3 rounded-lg border border-emerald-400 dark:border-emerald-600 bg-emerald-50 dark:bg-emerald-900/20 p-3 text-left hover:bg-emerald-100 dark:hover:bg-emerald-900/40 transition-colors"
          >
            <User className="h-5 w-5 mt-0.5 text-emerald-600" />
            <span>
              <span className="block text-sm font-medium text-emerald-900 dark:text-emerald-200">Also update employee profile</span>
              <span className="block text-xs text-emerald-700 dark:text-emerald-300">Applies to this payslip AND becomes the new default for future months.</span>
            </span>
          </button>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving} data-testid="apply-scope-cancel">Cancel</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
